var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("h5", { staticClass: "mt-3" }, [_vm._v("Upload Media")]),
        _vm.showPartsSelect
          ? _c("autocomplete-input", {
              attrs: {
                multiple: true,
                isObject: "",
                "track-by": "_id",
                path: `/products/${_vm.product._id}/parts/all`,
                optionsV: _vm.tempPart.productParts?.length
                  ? [..._vm.tempPart.productParts]
                  : [],
                loadOnFocus: "",
                name: "Assign to",
                customLabel: (e) =>
                  `${e?.partId} - ${e?.colors[0]?.name} ${
                    e?.ApparelSize?.label_size
                      ? `(${e?.ApparelSize?.label_size})`
                      : ""
                  }`,
              },
              on: { select: (p) => ({}), remove: (p) => ({}) },
              model: {
                value: _vm.tempPart.productParts,
                callback: function ($$v) {
                  _vm.$set(_vm.tempPart, "productParts", $$v)
                },
                expression: "tempPart.productParts",
              },
            })
          : _vm._e(),
        _c("UploadButton", {
          staticClass: "my-2",
          attrs: {
            accept: "*",
            mediaType: ["Image", "Document", "Video", "Audio"],
            artworks: _vm.storeArtworks,
            hasUploadFromLink: true,
            folder: _vm.uploadFolder,
            resize: "300",
            isLogo: _vm.isLogoMedia,
            defaultType: _vm.selectedType,
            compress: _vm.tempPart.compress,
            isResizeToSquare: true,
            visibleAttached: !_vm.tempPart._id,
            uploadOnly: !!_vm.tempPart._id,
          },
          on: {
            changeType: ($e) => (_vm.selectedType = $e),
            add: function ($event) {
              return _vm.saveMedia($event)
            },
            addArtwork: function ($event) {
              return _vm.selectImage($event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "settings",
              fn: function (props) {
                return [
                  _vm.selectedType === "Image"
                    ? _c(
                        "div",
                        { staticClass: "mb-3" },
                        [
                          _c("label", [_vm._v("Media Class")]),
                          _c("ProductMediaClassTypesMultiselect", {
                            attrs: { media: _vm.tempMedia, hasPreview: true },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("label", [_vm._v("Upload from computer")]),
                  _c(
                    "div",
                    { staticClass: "custom-control custom-checkbox mb-2" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tempPart.compress,
                            expression: "tempPart.compress",
                          },
                        ],
                        staticClass: "custom-control-input",
                        attrs: { id: `styled-checkbox`, type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.tempPart.compress)
                            ? _vm._i(_vm.tempPart.compress, null) > -1
                            : _vm.tempPart.compress,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.tempPart.compress,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.tempPart,
                                    "compress",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.tempPart,
                                    "compress",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.tempPart, "compress", $$c)
                            }
                          },
                        },
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: `styled-checkbox` },
                        },
                        [_vm._v("Compress")]
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.medias,
            callback: function ($$v) {
              _vm.medias = $$v
            },
            expression: "medias",
          },
        }),
        _vm.product.primaryProductId
          ? _c(
              "div",
              [
                _vm.loading ? _c("loading") : _vm._e(),
                _c("autocomplete-input", {
                  staticClass: "w-100",
                  attrs: {
                    path: `/products/${_vm.product.primaryProductId}/media-images?withPart=1&fieldsSearch=partDescription&fieldsSearch=partId&fieldsSearch=color`,
                    name: "Attach existing product media",
                    label: "Images",
                    loadOnFocus: "",
                    internalSearch: false,
                    isObject: "",
                    disabled: _vm.loading,
                    "track-by": "_id",
                    outValKey: true,
                    "options-v": [],
                  },
                  on: { select: _vm.selectImage },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (props) {
                          return [
                            _c("PartsDropdownOption", {
                              attrs: {
                                selectedPart: {
                                  partId: props.option.classTypeName,
                                  ...props.option.productPart[0],
                                  image: props.option,
                                },
                              },
                              on: { showPreview: _vm.showPreview },
                            }),
                          ]
                        },
                      },
                      {
                        key: "singleLabel",
                        fn: function (props) {
                          return [
                            _c("PartsDropdownOption", {
                              attrs: {
                                selectedPart: {
                                  partId: props.option.classTypeName,
                                  ...props.option.productPart[0],
                                  image: props.option,
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2219792573
                  ),
                  model: {
                    value: _vm.newImage,
                    callback: function ($$v) {
                      _vm.newImage = $$v
                    },
                    expression: "newImage",
                  },
                }),
              ],
              1
            )
          : _c("autocomplete-input", {
              staticStyle: { "max-width": "400px" },
              attrs: {
                path: `/products/${_vm.product._id}/media-images?withPart=1&fieldsSearch=partDescription&fieldsSearch=partId&fieldsSearch=color`,
                name: "Other Product Images",
                label: "Images",
                loadOnFocus: "",
                isObject: "",
                "track-by": "_id",
                internalSearch: false,
                outValKey: true,
                "options-v": [],
              },
              on: { select: _vm.selectImage },
              scopedSlots: _vm._u([
                {
                  key: "option",
                  fn: function (props) {
                    return [
                      _c("PartsDropdownOption", {
                        attrs: {
                          selectedPart: {
                            partId: props.option.classTypeName,
                            ...props.option.productPart[0],
                            image: props.option,
                          },
                        },
                        on: {
                          showPreview: _vm.showPreview,
                          hidePreview: _vm.hidePreview,
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "singleLabel",
                  fn: function (props) {
                    return [
                      _c("PartsDropdownOption", {
                        attrs: {
                          selectedPart: {
                            partId: props.option.classTypeName,
                            ...props.option.productPart[0],
                            image: props.option,
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.newImage,
                callback: function ($$v) {
                  _vm.newImage = $$v
                },
                expression: "newImage",
              },
            }),
      ],
      1
    ),
    _vm.showOrigin
      ? _c("div", { style: _vm.previewStyle }, [
          _c("img", {
            staticClass: "img-thumbnail mr-2",
            style: { minWidth: "300px" },
            attrs: { src: _vm.previewImage || "/img/loading-img.png" },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }